<template>
  <b-table
    :data="tableData"
    :default-sort="defaultSort"
    :default-sort-direction="defaultSortDirection"
    :detailed="detailed"
    hoverable
    :mobile-cards="false"

    :narrowed="isNarrow"
    :scrollable="isScrollable"
    :class="{'has-small-text': isSmallText}"
  >
    <slot></slot>

    <template #detail="props">
      <slot name="detail"></slot>
    </template>
  </b-table>
</template>

<script>
export default {
  name: "TableDefault",
  props: {
    tableData: {
      type: Array,
      required: true,
    },
    defaultSort: {
      type: [
        String,
        Array
      ],
    },
    defaultSortDirection: {
      type: String,
      default: "asc"
    },
    detailed: {
      type: Boolean,
      default: false,
    },
    isNarrow: {
      type: Boolean,
      default: false,
    },
    isScrollable: {
      type: Boolean,
      default: false,
    },
    isSmallText: {
      type: Boolean,
      default: false,
    },
  }
};
</script>

<style lang="scss" scoped>

::v-deep(.has-small-text) {
  font-size: 0.825rem;
}
</style>
